import { ContainerModule } from '@patsnap/tahiti-core/shared/inversify';
import { DateFormatterService } from './date-formatter/type/date-formatter-service.interface';
import { DateFormatterServiceImpl } from './date-formatter/date-formatter-service';
import { UserInfoFormatterServiceImpl } from './user-info-formatter/user-info-formatter-service';
import { UserInfoFormatterService } from './user-info-formatter/type/user-info-formatter-service.interface';
import { NumberFormatterService } from './number-formatter/type/number-formatter-service.interface';
import { NumberFormatterServiceImpl } from './number-formatter/number-formatter-service';
import { StorageService } from './local-storage/type/local-storage-service.interface';
import { LocalStorageServiceImpl } from './local-storage/local-storage-service';
import { DialogService } from './dialog-service/types/dialog-service.interface';
import { DialogServiceImpl } from './dialog-service/dialog-service';
export const utilServices = new ContainerModule((bind) => {
    bind(DateFormatterService).to(DateFormatterServiceImpl);
    bind(UserInfoFormatterService).to(UserInfoFormatterServiceImpl);
    bind(NumberFormatterService).to(NumberFormatterServiceImpl);
    bind(StorageService).to(LocalStorageServiceImpl);
    bind(DialogService).to(DialogServiceImpl).inTransientScope();
});
